module.exports = __webpack_public_path__ + "static/media/location.ae07c2a2.svg";